export const dispatchGeneralErrorEvent = (messageError = '', url = '') => {
  const event = new CustomEvent('generalerror', { detail: { messageError, url } });
  document.dispatchEvent(event);
};

const generalCatchError = (error) => {
  const messageError = error.response?.data?.displayMessage || error.response?.data?.message || '';
  const url = error.config?.url || error.request?.responseURL || '';
  dispatchGeneralErrorEvent(messageError, url);

  throw error;
};

export default generalCatchError;
